function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import AlertCloseButton from './AlertCloseButton';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { SVGIcon } from '@homeaway/react-svg';
import { ALERT_WARNING__24 } from '@homeaway/svg-defs';
import "./Alert.css";
/**
 * Alert
 *
 */

var Alert =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Alert, _Component);

  function Alert(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.removeAlert = function () {
      _this.setState({
        visible: false
      });

      if (_this.props.onAlertClosed) {
        _this.props.onAlertClosed();
      }
    };

    _this.dismissAlert = function () {
      _this.setState({
        dismissed: true
      });

      setTimeout(function () {
        _this.removeAlert();
      }, 500);
    };

    _this.alert = null;
    _this.state = {
      dismissed: false,
      visible: true
    };
    return _this;
  }

  var _proto = Alert.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        ariaLive = _this$props.ariaLive,
        title = _this$props.title,
        msg = _this$props.msg,
        svgClassName = _this$props.svgClassName,
        svgMarkup = _this$props.svgMarkup,
        svgId = _this$props.svgId,
        dismissible = _this$props.dismissible,
        closeText = _this$props.closeText,
        className = _this$props.className,
        onAlertClosed = _this$props.onAlertClosed,
        flairClassName = _this$props.flairClassName,
        rest = _objectWithoutProperties(_this$props, ["ariaLive", "title", "msg", "svgClassName", "svgMarkup", "svgId", "dismissible", "closeText", "className", "onAlertClosed", "flairClassName"]); // eslint-disable-line no-unused-vars


    var _this$state = this.state,
        dismissed = _this$state.dismissed,
        visible = _this$state.visible;
    var alertClass = classNames('Alert', 'border--default', {
      'Alert--dismissible': dismissible,
      'fade': dismissible,
      'in': !dismissed
    }, className);
    var flairClass = classNames('Alert__flair', flairClassName);
    var svgClass = classNames('Alert__svg', 'inline-svg', svgClassName);
    var finalIconMarkup;

    if (svgId) {
      finalIconMarkup = React.createElement(SVGIcon, {
        className: svgClass,
        id: svgId
      });
    } else if (svgMarkup) {
      finalIconMarkup = React.createElement(SVGIcon, {
        className: svgClass,
        markup: svgMarkup
      });
    }

    if (visible) {
      return React.createElement("div", _extends({
        ref:
        /* istanbul ignore next */
        function ref(e) {
          _this2.alert = e;
        },
        "aria-live": ariaLive,
        role: "alert",
        className: alertClass
      }, rest), React.createElement("div", {
        className: flairClass
      }), finalIconMarkup, dismissible && React.createElement(AlertCloseButton, {
        closeText: closeText,
        onClick: this.dismissAlert
      }), title && React.createElement("p", null, React.createElement("strong", null, title)), msg && React.createElement("p", null, msg), this.props.children);
    }

    return false;
  };

  return Alert;
}(Component);

Alert.propTypes = {
  /** The aria-live value for the alert.
   * 'polite' - indicates that the screen reader should wait until the user is idle before presenting updates to the user
   * 'assertive' may interupt user's flow
   */
  ariaLive: PropTypes.oneOf(['assertive', 'polite']),

  /** Alert heading, wrapped in an <h4> if you want it.  */
  title: PropTypes.string,

  /** Alert message to be formatted in a <p> tag.  You can also provide your own children markup/components */
  msg: PropTypes.node,

  /* CSS classes to apply to the svg. This is commented out since its meant as an internal property. */
  // svgClassName: PropTypes.string,

  /** SVG markup to display for Alert imported from @homeaway/svg-defs module. Please reference individual file in /lib/defs/ */
  svgMarkup: PropTypes.string,

  /** ID name of SVG from an SVG Definition block, the xlink:href of the SVG you want. Explicitly for use with SVG Definitions coming from the icon system in @homeaway/svg-defs */
  svgId: PropTypes.string,

  /** Flag to determine if the Alert has a close button and can be dismissed */
  dismissible: PropTypes.bool,

  /** Screen Reader .sr-only text for close button. Defaults to english: "Close" */
  closeText: PropTypes.string,

  /** Optional event handler to fire after an Alert has closed */
  onAlertClosed: PropTypes.func
  /** Background CSS helper for flair on left side of Alert. Internal use only. */
  // flairClassName: PropTypes.string

};
Alert.defaultProps = {
  ariaLive: 'polite',
  dismissible: false,
  closeText: 'Close',
  svgMarkup: ALERT_WARNING__24,
  flairClassName: 'bg--color-bg-active',
  svgClassName: 'text-muted'
};
export default Alert;
//# sourceMappingURL=Alert.js.map